export default __webpack_public_path__ + "static/media/Buyers_tab approved.cf8e079b.png";